import { DELIVERY_CLAIM_TYPE_CHOCO, DELIVERY_CLAIM_TYPE_CHOCO_EXPRESS, DELIVERY_CLAIM_TYPE_INHOUSE, DELIVERY_CLAIM_TYPE_INHOUSE_EXPRESS, DELIVERY_CLAIM_TYPE_WOLT, DELIVERY_CLAIM_TYPE_WOLT_EXPRESS, DELIVERY_CLAIM_TYPE_YANGO, DELIVERY_CLAIM_TYPE_YANGO_EXPRESS } from '@@partner:helpers/deliveryClaim'

export const DELIVERY_ZONE_STATUS_DISABLED = 0
export const DELIVERY_ZONE_STATUS_ENABLED = 1


export const DELIVERY_ZONE_STATUS_LABELS = [
  {
    label: 'Включён',
    value: DELIVERY_ZONE_STATUS_ENABLED
  },
  {
    label: 'Отключён',
    value: DELIVERY_ZONE_STATUS_DISABLED
  }
]

export const SLOT_DELIVERY_PROVIDERS = [
  {
    label: 'Свой курьер',
    value: DELIVERY_CLAIM_TYPE_INHOUSE
  },
  {
    label: 'Яндекс',
    value: DELIVERY_CLAIM_TYPE_YANGO
  },
  {
    label: 'Wolt',
    value: DELIVERY_CLAIM_TYPE_WOLT
  },
  {
    label: 'Choco',
    value: DELIVERY_CLAIM_TYPE_CHOCO
  }
]

export const EXPRESS_DELIVERY_PROVIDERS = [
  {
    label: 'Свой курьер экспресс',
    value: DELIVERY_CLAIM_TYPE_INHOUSE_EXPRESS
  },
  {
    label: 'Яндекс',
    value: DELIVERY_CLAIM_TYPE_YANGO_EXPRESS
  },
  {
    label: 'Wolt',
    value: DELIVERY_CLAIM_TYPE_WOLT_EXPRESS
  },
  {
    label: 'Choco',
    value: DELIVERY_CLAIM_TYPE_CHOCO_EXPRESS
  }
]